<mat-form-field [attr.data-form-field]="field" [appearance]="appearance" [formGroup]="formGroup" class="full-width">
  @if (label) {
    <mat-label class="label">{{ label | translate }}</mat-label>
  }
  <mat-chip-grid #chipList [required]="required">
    @for (chip of chips; track chip) {
      <mat-chip-row [removable]="true" (removed)="remove(chip.key)">
        {{ chip.value }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
    }

    <input
      [id]="field + '-input'"
      (blur)="updateAndValidate()"
      matInput
      #fieldInput
      [formControlName]="field"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="matChipInputTokenEnd()"
      />
    @if (suffixButtonIcon) {
      <button mat-icon-button matSuffix data-role="suffix-btn" [disabled]="suffixButtonAction === null" (click)="suffixButtonAction()">
        <mat-icon>{{ suffixButtonIcon }}</mat-icon>
      </button>
    }
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="notifyListeners($event)">
    @for (o of options | async; track o) {
      <mat-option [value]="o" [class]="field + '-list'">
        @if (displayTemplateRef) {
          <ng-container *ngTemplateOutlet="displayTemplateRef; context: { option: o }"></ng-container>
        } @else {
          @if (displayFn) {
            {{ displayFn(o) }}
          } @else {
            {{ o }}
          }
        }
      </mat-option>
    }
  </mat-autocomplete>

  <!-- The mat-error tag HAS to be directly inside the mat-form-field otherwise it doesn't render properly if inside the ng-container -->
  <mat-error>
    @for (e of errors; track e) {
      @if (formGroup.controls[field].hasError(e.error)) {
        <span [attr.data-form-field-error]="e.error">
          {{ e.messageKey | translate: formGroup.controls[field].getError(e.error) }}
        </span>
      }
    }
  </mat-error>
  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
